import { useEffect, useState } from "react"

import { Navigate, Outlet, useLocation } from "react-router-dom"

import { useSession } from "@/contexts/SessionContext"
import supabase from "@/supabase"

interface PrivateRouteProps {
  redirectPath?: string
}

const PrivateRoute = ({ redirectPath = "/login" }: PrivateRouteProps) => {
  const { session } = useSession()
  const [isLoading, setIsLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await supabase.auth.getSession()
        setIsLoading(false)
      } catch (error) {
        console.error("Error checking authentication:", error)
        setIsLoading(false)
      }
    }

    checkAuth()
  }, [])

  if (isLoading) {
    // You could replace this with a loading spinner component
    return <div className="flex h-screen items-center justify-center">Loading...</div>
  }

  // If not authenticated, redirect to login page with the return url
  if (!session) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />
  }

  // If authenticated, render the child routes
  return <Outlet />
}

export default PrivateRoute
